import axios from "axios";

import { baseAxios } from "config";

const resetInvoiceBatch = async ({ eventUrl, jobSlug, data }) => {
  const res = await baseAxios.post(`/payroll/invoices/reset/${data.invoiceId}`, data);
  return res;
};

export default resetInvoiceBatch;
